<i18n>
{
  "de": {
    "followToRead": "Folgen zum Lesen"
  },
  "en": {
    "followToRead": "Follow to read"
  }
}
</i18n>

<template>
  <div>
    <button
      class="button follow-button is-secondary is-flex is-small"
      @click="follow"
    >
      <heart-icon />
      <span>{{ $t('followToRead') }}</span>
    </button>
    <modal
      v-if="showFollowerModal"
      :backdropClose="true"
      :defaultHeader="false"
      :defaultFooter="true"
      @close="closeFollowModal"
    >
      <div slot="body">
        <div class="is-overlay">
          <section class="scale-hack">
            <div class="content">
              <div class="modal-card animated slideInDown login-modal pt-10 pl-10 pr-10">
                <follower-login @logged="closeFollowModal" />
              </div>
            </div>
          </section>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import followerLogin from '~/components/follower-login'
import heartIcon from '~/components/heart-icon'
import modal from '~/components/modal'

export default {
  name: 'post-follow-btn',
  props: ['singlePost'],
  components: { modal, followerLogin, heartIcon },
  data: () => ({
    showFollowerModal: false
  }),
  computed: {
    ...mapState(['isAuthenticated', 'artist']),
    avatarImageId() {
      if (
        !this.artist.profile ||
        typeof this.artist.profile.imgs.avatar === 'string'
      ) {
        return null
      }
      return this.artist.profile.imgs.avatar.name
    }
  },
  methods: {
    ...mapActions(['setFollowArtist', 'refreshFollowerPosts', 'refreshSinglePost']),
    async follow() {
      if (this.isAuthenticated) {
        const data = await this.apiPost(`/api/private/${this.artist.urlAlias}/follow/subscribe`, null, null)
        if (data && data.ok) {
          await this.setFollowArtist(true)
          if (this.singlePost) {
            await this.refreshSinglePost({ urlAlias: this.artist.urlAlias })
          }
          await this.refreshFollowerPosts({ urlAlias: this.artist.urlAlias })
          this.sendFlashMessage()
          this.$emit('followed')
        }
      } else {
        if (!this.singlePost) {
          this.showFollowerModal = true
          return
        }
        this.$emit('showGlobalFollowerModal')
        this.$root.$emit('showGlobalFollowerModal')
      }
    },
    closeFollowModal() {
      this.showFollowerModal = false
    },
    sendFlashMessage() {
      const imageId = this.artist.profile.imgs.avatar.name
      const flashConfig = {
        blockClass: 'flash-gn-profile-success'
      }
      if (this.avatarImageId) {
        flashConfig.icon = `/services/media/image/${this.artist._id}/${imageId}/128/0/image.webp`
      }
      this.$root.$emit('flash', {
        type: 'toasts.followship.created',
        state: 'success',
        flashConfig,
        payload: {
          artist: this.artist.nickname
        }
      })
    }
  }
}
</script>

<style lang="scss">
button.follow-button {
  padding: 0.9rem;
  padding-left: 0.4rem;

  &:hover {
    .heart {
      transform: scale(1.1);
    }
  }
}

.min-width {
  min-width: 200px;
}
</style>
